import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { useAppState, appActions } from '../hooks/useAppState';
import { localStorageUtils } from '../utils/localStorage';
import { Globe } from 'lucide-react';

const LanguageSwitcher: React.FC = () => {
  const { language, t } = useTranslation();
  const { state, dispatch } = useAppState();

  const toggleLanguage = () => {
    const newLanguage = language === 'nl' ? 'en' : 'nl';
    const updatedPreferences = {
      ...state.userPreferences,
      preferredLanguage: newLanguage as 'nl' | 'en',
    };
    
    dispatch(appActions.updatePreferences(updatedPreferences));
    localStorageUtils.saveUserPreferences(updatedPreferences);
  };

  return (
    <button
      className="language-switcher"
      onClick={toggleLanguage}
      aria-label={`${t('settings.language')}: ${language === 'nl' ? t('language.dutch') : t('language.english')}`}
      title={`${t('settings.language')}: ${language === 'nl' ? t('language.dutch') : t('language.english')}`}
    >
      <Globe size={20} />
      <span className="language-code">{language.toUpperCase()}</span>
    </button>
  );
};

export default LanguageSwitcher;

